import { Typography } from 'antd';
import styled from '@emotion/styled';
export const Text = styled(Typography.Text)``;
